export const ACCOUNT_STATUS_ANONYMUS = Symbol('ACCOUNT_STATUS_ANONYMUS')
export const ACCOUNT_STATUS_JUROR_INACTIVE = Symbol(
  'ACCOUNT_STATUS_JUROR_INACTIVE'
)
export const ACCOUNT_STATUS_JUROR_ACTIVE = Symbol('ACCOUNT_STATUS_JUROR_ACTIVE')
